<template>
  <div>
    <navi-header />
    <main role="main">
      <div class="contents-box my-2 py-2">
        <div class="container">
          <room-info />
        </div>
        <step @changeCurrentStep="onStepSelected" />
      </div>
      <welcome v-if="isFirstStep"/>
      <h2 class="contents-title font-weight-bold container mt-3">STEP{{reservationStep}}</h2>
        <div class="contents-box my-2">
          <div class="container py-3">
            <h3 class="h5 font-weight-bold">物件に向かっていただきます。</h3>
            <p class="mb-1 mt-3">
              物件住所: {{propertyAddress}}<br />
              最寄り駅: {{propertyStationLine}} {{propertyStation}}駅<br />
            </p>
            <p>
              <span class="badge bg-primary">目的地</span>
              {{reservationRoomWithProperty}}
            </p>
            <div id="map" class='map border border-primary mb-3' style='height:300px;' v-if="haveLatLon">
              <GmapMap
                :center="gmap.center"
                :zoom="gmap.zoom"
                map-type-id="roadmap"
                style="width: 100%; height: 100%;"
                :options="gmap.mapStyle">
                  <GmapMarker v-for="(item, index) in gmap.markerItems"
                  :position="item.position"
                  :title="item.title"
                  :key="index"
                  :clickable="true"
                  :draggable="false"
                  @click="toggleInfoWindow(item)">
                  </GmapMarker>
                  <GmapInfoWindow
                    :options="gmap.infoOptions"
                    :position="gmap.infoWindowPosition"
                    :opened="gmap.infoWindowOpen"
                    @closeclick="gmap.infoWindowOpen=false">
                    {{reservationRoomWithProperty}}
                  </GmapInfoWindow>
              </GmapMap>
            </div>
            <div class="text-right">
              <a :href="gmapNaviUrl" class="btn btn-outline-secondary btn-sm" target='_blank'>
                <img src="~navi/icon_pin.png" width="16" class="align-text-top">
                マップアプリで確認する
              </a>
            </div>
        </div>
      </div>

      <h2 class="contents-title font-weight-bold container mt-3">STEP{{reservationStep}}-2</h2>
      <div class="contents-box my-2">
        <div class="container py-3">
          <h3 class="h5 font-weight-bold">到着したらチャットより、到着した旨をお送りください。</h3>
          <div class="text-center mb-3">
            <img src="~navi/phone_chat.png" width="160" alt="chat">
          </div>
          <div class="text-center mb-1">
            <a href="" class="btn btn-outline-secondary rounded-pill px-5 py-2" @click.prevent="onChatOpenClicked()">チャットを開く</a>
          </div>
        </div>
      </div>
    </main>
    <navi-footer @goToNextStep="onNextStepSelected" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NaviHeader from '@/components/navi/common/Header'
import RoomInfo from '@/components/navi/common/RoomInfo'
import Step from '@/components/navi/common/Step'
import Welcome from '@/components/navi/common/Welcome'
import NaviFooter from '@/components/navi/common/Footer'
export default {
  name: 'MoveToProperty',
  components: { NaviHeader, RoomInfo, Step, NaviFooter, Welcome },
  data() {
    return {
      gmap: {
        center: {},
        zoom: 17,
        mapStyle: {
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          zoomControl: true,
        },
        markerItems: [],
        infoWindowPosition: null,
        infoWindowOpen: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
      }
    }
  },
  mounted() {
    if(this.haveLatLon){
      const center = { lat: parseFloat(this.propertyLat),
                       lng: parseFloat(this.propertyLon) }
      this.gmap.center = center
      const marker = { id: this.reservationId,
                       title: this.reservationRoomWithProperty,
                       position: center }
      this.gmap.markerItems.push(marker)
    }
  },
  computed: {
    ...mapGetters('reservation', ['reservationId', 'reservationStep', 'reservationRoomWithProperty']),
    ...mapGetters('flowDetails', ['flowDetailsAll']),
    ...mapGetters('property', ['propertyAddress', 'propertyStation', 'propertyStationLine', 'propertyLat', 'propertyLon']),
    isFirstStep() {
      return this.reservationStep == 1
    },
    isLastStep() {
      return this.flowDetailsAll.length == this.reservationStep
    },
    haveLatLon(){
      return (this.propertyLat != null && this.propertyLon != null)
    },
    gmapNaviUrl() {
      return `https://www.google.com/maps/dir/?api=1&destination=${parseFloat(this.propertyLat)}, ${parseFloat(this.propertyLon)}&travelmode=walking`
    }
  },
  methods: {
    onNextStepSelected() {
      this.$emit('goToNextStep')
    },
    onStepSelected() {
      this.$emit('setCurrentFlowDetail')
    },
    onChatOpenClicked() {
      $('.open-chat-btn').click()
    },
    toggleInfoWindow(marker) {
      this.gmap.infoWindowPosition = marker.position
      this.gmap.infoWindowOpen = true
    }
  }
}
</script>

<style scoped>
</style>
